export default {
  getTooltipById: state => id => state.tooltips?.filter(item => item.id === id)[0] || null,
  getTooltipBySlug: state => slug => state.tooltips?.filter(item => item.Slug === slug)[0] || null,
  getTooltipTextById: (state, getters) => id => getters.getTooltipById(id)?.Text || '',
  getTooltipTextBySlug: (state, getters) => slug => getters.getTooltipBySlug(slug)?.Text || '',
  getProductImageById: (state, getters) => id => getters.getTooltipById(id)?.Image?.url || null,
  getProductImageBySlug: (state, getters) => slug => getters.getTooltipBySlug(slug)?.Image?.url || null
}
